var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkComponent',{attrs:{"showIcon":false,"title":"Portal del SRI","classNames":"text-color-secondary"},on:{"onClick":_vm.redirectPortalSRI}})
}
var staticRenderFns = []

export { render, staticRenderFns }